interface Params {
	auth: { uid?: string };
	meeting: { hostUid: string; guestUid: string };
}

export function isOwnMeeting({
	auth: { uid },
	meeting: { hostUid, guestUid }
}: Params) {
	if (!uid) {
		return false;
	}
	const userIsHost = !!hostUid && hostUid === uid;
	const userIsGuest = !!guestUid && guestUid === uid;

	return userIsHost || userIsGuest;
}
